import {
    Component,
    Input,
    Inject,
    forwardRef,
    KeyValueDiffer,
    KeyValueDiffers,
    DoCheck,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core'

import { noop } from '@app-lib/common.lib'
import { connectConfigure } from 'instantsearch.js/es/connectors'
import {
    ConfigureWidgetDescription,
    ConfigureRenderState,
    ConfigureConnectorParams,
} from 'instantsearch.js/es/connectors/configure/connectConfigure'
import { AbstractInstantsearchWidgetComponent } from '@app-domains/instantsearch/abstract-instantsearch-widget.component'
import { InstantsearchComponent } from '@app-domains/instantsearch/components/instantsearch.component'

@Component({
    selector: 'app-instantsearch-configure',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class InstantsearchConfigureComponent extends AbstractInstantsearchWidgetComponent<
ConfigureWidgetDescription,
ConfigureConnectorParams
> implements OnInit, DoCheck {
    public widgetName: string

    private internalSearchParameters: ConfigureConnectorParams['searchParameters']

    private differ: KeyValueDiffer<string, any>

    public override state: ConfigureRenderState = {
        refine: noop,
    }

    constructor(
        private differs: KeyValueDiffers,

        @Inject(forwardRef(() => InstantsearchComponent))
        public instantSearchInstance: InstantsearchComponent,
    ) {
        super()
    }

    @Input()
    set searchParameters(values: ConfigureConnectorParams['searchParameters']) {
        this.internalSearchParameters = values

        if (! this.differ && values) {
            this.differ = this.differs.find(values).create()
        }
    }

    public override ngOnInit() {
        this.createWidget(
            connectConfigure,
            {
                searchParameters: this.internalSearchParameters,
            },
            {
                $$widgetType: 'ais.configure',
            },
        )
        super.ngOnInit()
    }

    public ngDoCheck() {
        if (this.differ) {
            const changes = this.differ.diff(this.internalSearchParameters)
            if (changes) {
                this.state.refine(this.internalSearchParameters)
            }
        }
    }
}
